import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const supplierUrl = "api/v1/party-app";

//obtaining the paginated data
export const getSupplier = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${supplierUrl}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllSupplier = () => axiosInstance.get(`${supplierUrl}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSupplier = ({ number, rowsPerPage, search }) =>
  // axiosInstance.get(`${supplierUrl}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);
  axiosInstance.get(`${supplierUrl}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//
export const getSupplierById = (id) => axiosInstance.get(`${supplierUrl}/retrieve/${id}`);

//creating function
export const createSupplier = (body) =>
  axiosInstance.post(`${supplierUrl}/create-all`, body, {
    "Content-Type": "multipart/form-data",
  });
//updating function
export const updateSupplier = (id, body) =>
  axiosInstance.patch(`${supplierUrl}/update/${id}`, body, {
    "Content-Type": "multipart/form-data",
  });

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${supplierUrl}/list?offset=0&limit=${rowsPerPage}&search=${search}`);
